import React from 'react';
import styled, { css } from 'styled-components';
import { Cross1Icon } from '@radix-ui/react-icons';

import styles from './alert.module.scss';

interface AlertProps {
  type?: string;
  text: string;
  small?: boolean;
  onDelete?: () => void;
}

export const Alert: React.FC<AlertProps> = ({ type = 'default', text, small = false, onDelete }) => (
  <AlertItem type={type} small={small} close={!!onDelete}>
    <div>{text}</div>

    {!!onDelete && (
      <div className={styles.close} onClick={onDelete}>
        <Cross1Icon />
      </div>
    )}
  </AlertItem>
);

interface AlertItemProps {
  type: string;
  small: boolean;
  close: boolean;
}

const AlertItem = styled.div<AlertItemProps>`
  position: relative;
  color: var(--color-error);
  border: 2px solid var(--color-error);
  border-radius: 0.6rem;
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: 0;
  line-height: 1.2rem;
  text-transform: uppercase;
  display: inline-block;
  padding: ${({ small }) => (small ? '.4rem 1.6rem' : '.8rem 1.6rem')};
  padding-right: ${({ close }) => (close ? '2.4rem' : '1.6rem')};

  ${(props) => {
    switch (props.type) {
      case 'error':
        return css`
          background-color: var(--color-error);
          color: var(--white-default);
          border: 2px solid var(--color-error);
        `;
      case 'success':
        return css`
          background-color: var(--color-success);
          color: var(--white-default);
          border: 2px solid var(--color-success);
        `;
      case 'data':
        return css`
          background-color: var(--color-primary);
          color: var(--white-default);
          border: 2px solid var(--color-primary);
        `;
      case 'warning':
        return css`
          background-color: var(--color-warning);
          color: var(--white-default);
          border: 2px solid var(--color-warning);
        `;
      default:
        return css`
          background-color: transparent;
          color: var(--color-error);
          border: 2px solid var(--color-error);
        `;
    }
  }};
`;
